<div class="loader-with-message">
	<cmv-loader [size]="loaderSize"></cmv-loader>
	<ng-content></ng-content>
</div>
